import { render } from "./directors.vue?vue&type=template&id=4120c280&lang=html"
import script from "./directors.vue?vue&type=script&lang=js"
export * from "./directors.vue?vue&type=script&lang=js"

import "./directors.vue?vue&type=style&index=0&id=4120c280&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__